import Vue from 'vue'
import VueI18n from 'vue-i18n';
import messages from './language.json'


Vue.use(VueI18n);
// when full translation navigator.language.substring(0, 2)
const i18n = new VueI18n({ locale: 'fr', messages} );
export default i18n;
